"use client";
import clsx from "clsx";
import { useVisibility } from "src/lib/Visibility";
import styles from "./LoadingIndicator.module.scss";

export interface LoadingIndicatorProps {
  className?: string;
}

const LoadingIndicator = (props: LoadingIndicatorProps) => {
  const { className, ...otherProps } = props;

  const resolvedColor = "var(--color-primary)";

  const { visible } = useVisibility();

  return (
    <span
      className={clsx(styles.wrapper, className)}
      {...otherProps}
      data-visible={Boolean(visible)}
    >
      <svg
        className={styles.spinner}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
        style={{ color: resolvedColor }}
      >
        <circle className={styles.arc} cx="12" cy="12" r="9" />
      </svg>
    </span>
  );
};

export default LoadingIndicator;
